import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { ProductCard } from "@/components/ProductCard";

export function Featured() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api
      .get("/products", { params: { featured: true } })
      .then(({ data }) => setProducts(data.slice(0, 8)))
      .catch(() => {});
  }, []);

  return (
    <section className="bg-cream py-24 md:py-32" data-testid="featured">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="mb-14 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="eyebrow text-gold">Loved By Everyone</p>
            <h2 className="mt-4 font-serif text-4xl font-light leading-none tracking-tight text-ink md:text-6xl">
              Featured Pieces
            </h2>
          </div>
          <Link to="/shop" className="eyebrow link-underline text-ink/70" data-testid="featured-view-all">
            Shop All
          </Link>
        </Reveal>

        <div className="grid grid-cols-2 gap-x-4 gap-y-12 md:grid-cols-4 md:gap-x-6">
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
